<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Corrección de reservas</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 md4>
                <empresa-select v-model="empresa"></empresa-select>
            </v-flex>
            <v-flex xs12 md4>
                <v-text-field label="Deposito" v-model="deposito"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
                <v-text-field label="Producto" v-model="producto"></v-text-field>
            </v-flex>
            <v-flex xs12 md4>
                <v-text-field label="Lote" v-model="lote"></v-text-field>
            </v-flex>
            <v-flex>
                <v-btn color="green" dark @click="getData" :loading="loadingData">Obtener datos</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-text-field label="Saldo" :value="sb2.B2_QATU"></v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field label="Reservado" :value="sb2.B2_RESERVA"></v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field label="Reservado por requisiciones" :value="sb2.B2_QEMP"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-text-field label="Saldo por lote" :value="sb8.B8_SALDO"></v-text-field>
            </v-flex>
            <v-flex>
                <v-text-field label="Reservado por lote" :value="sb8.B8_EMPENHO"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-text-field label="Restar cantidad..." v-model="cambio"></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-btn color="green" dark @click="procesar">Procesar</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import EmpresaSelect from "../../components/EmpresaSelect";
    import {mapActions} from "vuex";
    import moneda from "../../filters/moneda";

    export default {
        name: "pedido_libera",
        components: {EmpresaSelect},
        data() {
            return {
                deposito: '',
                producto: '',
                lote: '',
                empresa: '3',
                loadingData: false,
                edit: [],
                sb2: {B2_QATU: 0, B2_RESERVA: 0, B2_QEMP: 0},
                sb8: {B8_EMPENHO: 0, B8_SALDO: 0},
                cambio: 0
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            getData() {
                this.loadingData = true;
                this.$http.post('varios/reserva-fix/datos', {
                    deposito: this.deposito,
                    producto: this.producto,
                    lote: this.lote,
                    empresa: this.empresa
                })
                    .then(r => {
                        this.sb8 = r.data.sb8;
                        this.sb2 = r.data.sb2;
                        this.loadingData = false;
                    })
                    .finally(() => {
                        this.loadingData = false;
                    })
            },
            procesar() {
                this.loading = true;
                this.$http.post('varios/reserva-fix/procesar', {
                    deposito: this.deposito,
                    producto: this.producto,
                    lote: this.lote,
                    empresa: this.empresa,
                    cambio: this.cambio
                })
                    .then(r => {
                        this.msjShow(r.data);
                        this.loading = false;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/varios/reserva_fix.vue